"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.symbol.async-iterator.js");

require("core-js/modules/es.symbol.to-string-tag.js");

require("core-js/modules/es.json.to-string-tag.js");

require("core-js/modules/es.math.to-string-tag.js");

require("core-js/modules/es.object.get-prototype-of.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.silenceAudioBase64 = exports.PlaylistAudiotrack = exports.LOGGABLE_HOWL_EVENTS = exports.LOGGABLE_AUDIO_ELEMENT_EVENTS = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.to-fixed.js");

var _audioPanner = require("./audioPanner");

var _AssetEnvelope = require("./mixer/AssetEnvelope");

var _TrackOptions = require("./mixer/TrackOptions");

var _TrackStates = require("./TrackStates");

var _utils = require("./utils");

var _excluded = ["listenTagIds"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
@see https://github.com/loafofpiecrust/roundware-ios-framework-v2/blob/client-mixing/RWFramework/RWFramework/Playlist/AudioTrack.swift

 Audiotracks data looks like this:

 [{
   "id": 8,
   "minvolume": 0.7,
   "maxvolume": 0.7,
   "minduration": 200.0,
   "maxduration": 250.0,
   "mindeadair": 1.0,
   "maxdeadair": 3.0,
   "minfadeintime": 2.0,
   "maxfadeintime": 4.0,
   "minfadeouttime": 0.3,
   "maxfadeouttime": 1.0,
   "minpanpos": 0.0,
   "maxpanpos": 0.0,
   "minpanduration": 10.0,
   "maxpanduration": 20.0,
   "repeatrecordings": false,
   "active": true,
   "start_with_silence": false,
   "banned_duration": 600,
   "tag_filters": [],
   "project_id": 9
 }]


 asset looks like:

 {
  alt_text_loc_ids: []
  audio_length_in_seconds: 14.4
  created: "2019-03-13T20:09:34.237155"
  description: ""
  description_loc_ids: []
  end_time: 14.396
  envelope_ids: [6204]
  file: "https://prod.roundware.com/rwmedia/20190313-200933-43867.mp3"
  filename: "20190313-200933-43867.wav"
  id: 11511
  language_id: 1
  latitude: 42.4985662
  longitude: -71.2809467
  media_type: "audio"
  project_id: 27
  session_id: 43867
  shape: null
  start_time: 0
  submitted: true
  tag_ids: [290]
  updated: "2019-03-13T20:09:34.237155"
  user: null
  volume: 1
  weight: 50
  }

*/
//const LOGGABLE_AUDIO_ELEMENT_EVENTS = ['loadstart','playing','stalled','waiting']; // see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement#Events
var LOGGABLE_AUDIO_ELEMENT_EVENTS = ["pause", "play", "playing", "waiting", "stalled", "about", "canplay", "canplaythrough", "ended", "error", "loadeddata", "loadstart"]; // see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement#Events

exports.LOGGABLE_AUDIO_ELEMENT_EVENTS = LOGGABLE_AUDIO_ELEMENT_EVENTS;
var LOGGABLE_HOWL_EVENTS = ["load", "loaderror", "playerror", "play", "end", "pause", "stop", "mute", "volume", "rate", "seek", "fade", "unlock"];
exports.LOGGABLE_HOWL_EVENTS = LOGGABLE_HOWL_EVENTS;
var silenceAudioBase64 = "data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
exports.silenceAudioBase64 = silenceAudioBase64;
var NEARLY_ZERO = 0.0001;

var PlaylistAudiotrack = /*#__PURE__*/function () {
  /**
   * id of audiotrack
   * @type {number}
   * @memberof PlaylistAudiotrack
   */

  /**
   * @type {Playlist}
   * @memberof PlaylistAudiotrack
   */

  /**
   *
   * Logs asset events to roundware server
   * @type {RoundwareEvents}
   * @memberof PlaylistAudiotrack
   */
  function PlaylistAudiotrack(_ref) {
    var _this = this;

    var audioContext = _ref.audioContext,
        windowScope = _ref.windowScope,
        audioData = _ref.audioData,
        playlist = _ref.playlist,
        client = _ref.client;

    _classCallCheck(this, PlaylistAudiotrack);

    _defineProperty(this, "played", false);

    _defineProperty(this, "pausedAssetId", null);

    _defineProperty(this, "isSafeToPlay", false);

    this.trackId = audioData.id;
    this.timedAssetPriority = audioData.timed_asset_priority;
    this.playlist = playlist;
    this.playing = false;
    this.windowScope = windowScope;
    this.listenEvents = client.events;
    this.currentAsset = null;
    this.audioData = audioData;
    var audioElement = new Audio();
    audioElement.crossOrigin = "anonymous";
    audioElement.loop = false;
    audioElement.src = silenceAudioBase64;
    var audioSrc = audioContext.createMediaElementSource(audioElement);
    this.gainNode = audioContext.createGain();
    var panNode = audioContext.createStereoPanner();
    audioSrc.connect(panNode).connect(this.gainNode).connect(audioContext.destination); // LOGGABLE_AUDIO_ELEMENT_EVENTS.forEach((name) =>
    //   audioElement.addEventListener(name, () =>
    //     console.log(`\t[${this} audio ${name} event]`)
    //   )
    // );

    audioElement.addEventListener("error", function () {
      return _this.onAudioError();
    });
    audioElement.addEventListener("ended", function () {
      return _this.onAudioEnded();
    });
    var trackOptions = new _TrackOptions.TrackOptions(function (param) {
      return (0, _utils.getUrlParam)(windowScope.location.toString(), param);
    }, audioData);
    audioElement.addEventListener("playing", function () {
      if (!_this.isSafeToPlay) return;
      if (_this.playlist.playing === false) return _this.pauseAudio();
      if (_this.currentAsset) _this.currentAsset.status = undefined;

      if (_this.currentAsset) {
        var _this$listenEvents;

        (_this$listenEvents = _this.listenEvents) === null || _this$listenEvents === void 0 ? void 0 : _this$listenEvents.logAssetStart(_this.currentAsset.id);
        _this.playing = true;
        _this.played = true;
      }
    });
    audioElement.addEventListener("pause", function () {
      var _this$listenEvents2, _this$currentAsset;

      _this.playing = false;
      (_this$listenEvents2 = _this.listenEvents) === null || _this$listenEvents2 === void 0 ? void 0 : _this$listenEvents2.logAssetEnd((_this$currentAsset = _this.currentAsset) === null || _this$currentAsset === void 0 ? void 0 : _this$currentAsset.id);
    });
    audioElement.addEventListener("end", function () {
      var _this$listenEvents3, _this$currentAsset2;

      return (_this$listenEvents3 = _this.listenEvents) === null || _this$listenEvents3 === void 0 ? void 0 : _this$listenEvents3.logAssetEnd((_this$currentAsset2 = _this.currentAsset) === null || _this$currentAsset2 === void 0 ? void 0 : _this$currentAsset2.id);
    });
    this.audioContext = audioContext;
    this.audioElement = audioElement;
    this.trackOptions = trackOptions;
    this.mixParams = {
      timedAssetPriority: audioData.timed_asset_priority,
      listenTagIds: audioData.tag_filters
    };
    var minpanpos = audioData.minpanpos,
        maxpanpos = audioData.maxpanpos,
        minpanduration = audioData.minpanduration,
        maxpanduration = audioData.maxpanduration;
    this.audioPanner = new _audioPanner.AudioPanner(minpanpos, maxpanpos, minpanduration, maxpanduration, panNode, audioContext);
    this.audioPanner.start();
    this.setInitialTrackState();
    var that = this; // try to play silence audio to avoid NotAllowedError on iOS

    (0, _utils.makeAudioSafeToPlay)(this.audioElement, this.audioContext, function () {
      that.isSafeToPlay = true;
      console.log("successfully ".concat(that.audioData.id, " ").concat(that.isSafeToPlay));
    });
  }

  _createClass(PlaylistAudiotrack, [{
    key: "setInitialTrackState",
    value: function setInitialTrackState() {
      this.state = (0, _TrackStates.makeInitialTrackState)(this, this.trackOptions);
    }
  }, {
    key: "onAudioError",
    value: function onAudioError(evt) {
      (0, _utils.playlistTrackLog)("".concat(this, " audio error, skipping to next track"));
      this.setInitialTrackState();
    }
  }, {
    key: "onAudioEnded",
    value: function onAudioEnded() {
      (0, _utils.playlistTrackLog)("".concat(this, " audio ended event"));
    }
  }, {
    key: "play",
    value: function play() {
      if (!this.state) return;
      this.state.play();
    }
  }, {
    key: "updateParams",
    value: function updateParams() {
      var _this$mixParams, _this$mixParams$liste;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$listenTagIds = _ref2.listenTagIds,
          listenTagIds = _ref2$listenTagIds === void 0 ? [] : _ref2$listenTagIds,
          params = _objectWithoutProperties(_ref2, _excluded);

      (_this$mixParams = this.mixParams) === null || _this$mixParams === void 0 ? void 0 : (_this$mixParams$liste = _this$mixParams.listenTagIds) === null || _this$mixParams$liste === void 0 ? void 0 : _this$mixParams$liste.concat.apply(_this$mixParams$liste, _toConsumableArray(listenTagIds));
      this.mixParams = _objectSpread(_objectSpread({}, this.mixParams), params);
      if (this.state) this.state.updateParams(this.mixParams);
    } // Halts any scheduled gain changes and holds at current level
    // @see https://developer.mozilla.org/en-US/docs/Web/API/AudioParam/cancelAndHoldAtTime

  }, {
    key: "holdGain",
    value: function holdGain() {
      this.gainNode.gain.cancelScheduledValues(0);
    }
  }, {
    key: "setZeroGain",
    value: function setZeroGain() {
      this.gainNode.gain.value = NEARLY_ZERO;
    }
  }, {
    key: "fadeIn",
    value: function fadeIn(fadeInDurationSeconds) {
      var currentAsset = this.currentAsset;
      if (!currentAsset || !currentAsset.volume) return false;
      var randomVolume = this.trackOptions.randomVolume;
      var finalVolume = randomVolume * currentAsset.volume;

      try {
        this.setZeroGain();
        this.rampGain(finalVolume || NEARLY_ZERO, fadeInDurationSeconds);
        return true;
      } catch (err) {
        (0, _utils.playlistTrackLog)("".concat(this, " unable to fadeIn"));
        return false;
      }
    }
    /**
     * Schedules a Fade out and returns true if success
     *
     * @param {number} fadeOutDurationSeconds
     * @return {*}  {boolean}
     * @memberof PlaylistAudiotrack
     */

  }, {
    key: "fadeOut",
    value: function fadeOut(fadeOutDurationSeconds) {
      var _this$currentAsset3, _this$currentAsset4;

      if (fadeOutDurationSeconds > ((_this$currentAsset3 = this.currentAsset) === null || _this$currentAsset3 === void 0 ? void 0 : _this$currentAsset3.audio_length_in_seconds) - this.audioElement.currentTime) fadeOutDurationSeconds = ((_this$currentAsset4 = this.currentAsset) === null || _this$currentAsset4 === void 0 ? void 0 : _this$currentAsset4.audio_length_in_seconds) - this.audioElement.currentTime;
      return this.rampGain(0, fadeOutDurationSeconds);
    }
  }, {
    key: "rampGain",
    value: function rampGain(finalVolume, durationSeconds) {
      console.log("\t[ramping gain from ".concat(this.gainNode.gain.value, " to ").concat(finalVolume.toFixed(2), " (").concat(durationSeconds.toFixed(1), "s)]"));

      try {
        this.gainNode.gain.setValueAtTime(this.gainNode.gain.value, this.audioContext.currentTime);
        this.gainNode.gain.exponentialRampToValueAtTime(finalVolume || NEARLY_ZERO, this.audioContext.currentTime + durationSeconds);
        return true;
      } catch (err) {
        console.warn("Unable to ramp gain ".concat(this), err);
        return false;
      }
    }
    /**
     *This will perform cleanup, get next asset to play and update/set the `src` property to current audio
     *
     * @return {*}  {(IAssetData | null)}
     * @memberof PlaylistAudiotrack
     */

  }, {
    key: "loadNextAsset",
    value: function loadNextAsset() {
      var audioElement = this.audioElement,
          currentAsset = this.currentAsset,
          trackOptions = this.trackOptions; // if current asset was not played at all then don't increase playCount

      if (currentAsset && this.played) {
        // make sure its a number initialized to 0;
        if (typeof currentAsset.playCount !== "number") currentAsset.playCount = 0; // dont increment play count if asset was paused / as it isn't finished yey

        if (currentAsset.status != "paused") {
          currentAsset.playCount++;
        }

        currentAsset.lastListenTime = new Date().getTime();
      }

      var newAsset = this.playlist.next(this);
      this.currentAsset = newAsset || null;

      if (newAsset) {
        var file = newAsset.file,
            start_time = newAsset.start_time;
        (0, _utils.playlistTrackLog)("#".concat(this.trackId, " Selected Asset: ").concat(newAsset.id, ", was paused: ").concat(newAsset.status == "paused", "]"));
        this.assetEnvelope = new _AssetEnvelope.AssetEnvelope(trackOptions, newAsset);

        if (typeof file !== "string") {
          return null;
        }

        audioElement.src = file;
        audioElement.addEventListener("loadedmetadata", function () {
          if (newAsset.status === "resumed") audioElement.currentTime = newAsset.resume_time || start_time;else audioElement.currentTime = start_time;
        }, {
          once: true
        });
        this.played = false;
        return newAsset;
      }

      return null;
    }
  }, {
    key: "pause",
    value: function pause() {
      (0, _utils.playlistTrackLog)("".concat(_utils.timestamp, " pausing ").concat(this));
      if (!this.state) return;
      this.state.pause();
      this.pauseAudio();
    }
  }, {
    key: "playAudio",
    value: function () {
      var _playAudio = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(this.audioContext.state !== "running")) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.audioContext.resume();

              case 4:
                if (!this.audioElement.src) this.audioElement.src = silenceAudioBase64;
                _context.next = 7;
                return this.audioElement.play();

              case 7:
                console.log("".concat(this.audioData.id, " works"));
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.error("".concat(this.audioData.id), _context.t0);
                this.setInitialTrackState();
                this.transition(this.state);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function playAudio() {
        return _playAudio.apply(this, arguments);
      }

      return playAudio;
    }()
  }, {
    key: "pauseAudio",
    value: function pauseAudio() {
      if (!this.audioElement.paused) this.audioElement.pause();
    }
    /**
     *
     * Fade Out currently playing asset quickly and get nextAsset
     * @return {void}
     * @memberof PlaylistAudiotrack
     */

  }, {
    key: "skip",
    value: function skip() {
      var _this2 = this;

      if (!this.playlist.playing) {
        this.setInitialTrackState();
        return;
      }

      this.fadeOut(this.trackOptions.fadeOutLowerBound);
      setTimeout(function () {
        var _this2$listenEvents, _this2$currentAsset;

        _this2.pauseAudio();

        (_this2$listenEvents = _this2.listenEvents) === null || _this2$listenEvents === void 0 ? void 0 : _this2$listenEvents.logAssetEnd((_this2$currentAsset = _this2.currentAsset) === null || _this2$currentAsset === void 0 ? void 0 : _this2$currentAsset.id);
        var newState = (0, _TrackStates.makeInitialTrackState)(_this2, _this2.trackOptions);
        if (_this2.playlist.playing) _this2.transition(newState);
      }, this.trackOptions.fadeOutLowerBound * 1000);
    }
  }, {
    key: "replay",
    value: function replay() {
      var state = this.state;
      (0, _utils.playlistTrackLog)("Replaying ".concat(this));
      if (state) state.replay();
    }
  }, {
    key: "transition",
    value: function transition(newState) {
      var state = this.state,
          elapsedTimeMs = this.playlist.elapsedTimeMs;
      (0, _utils.playlistTrackLog)("".concat(_utils.timestamp, " ").concat(this, ": '").concat(state, "' \u279C  '").concat(newState, "' (").concat((elapsedTimeMs / 1000).toFixed(1), "s elapsed)"));
      if (!this.state) return;
      this.state.finish();
      this.state = newState;
      if (this.playlist.playing) this.state.play();
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Track #".concat(this.trackId);
    }
  }]);

  return PlaylistAudiotrack;
}();

exports.PlaylistAudiotrack = PlaylistAudiotrack;